import React from 'react';

import SubjectName from './SubjectName';
import {Props as BasicProps} from './SubjectBasic';
import {LetterGrade} from '../constants';
import LetterGradeSelector from './LetterGradeSelector';

type Props = Readonly<
  BasicProps & {
    letterOptions: ReadonlyArray<LetterGrade>;
  }
>;

export default function SubjectWithLetterScore(props: Props) {
  const subject = props.subject;
  const inputID = `score_${subject.ID_SUBJECT}`;

  return (
    <li
      className="px-2 flex justify-between items-center"
      id={`subject_${subject.ID_SUBJECT}`}>
      <SubjectName
        inputID={inputID}
        subject={subject}
        onDeleteSubject={props.onDeleteSubject}
      />
      <label className="subject_score text-base">
        Score:{' '}
        <LetterGradeSelector
          inputID={inputID}
          options={props.letterOptions}
          value={subject.fields.grade || null}
          onChange={(grade: LetterGrade | null) => {
            props.onUpdateSubject(subject.ID_SUBJECT, {
              ...subject.fields,
              grade,
            });
          }}
        />
      </label>
    </li>
  );
}
